/*
  Product page helpers.

  The gallery marks the active thumbnail with a slider class only; mirror it into
  aria-current so assistive technology knows which image is showing.
*/
(function () {
  var ACTIVE = 'swiper-slide-thumb-active';

  function sync(list) {
    list.querySelectorAll('.product__thumbs-item').forEach(function (item) {
      var target = item.querySelector('.product__thumbs-container') || item;
      if (item.classList.contains(ACTIVE)) {
        target.setAttribute('aria-current', 'true');
      } else {
        target.removeAttribute('aria-current');
      }
    });
  }

  function init() {
    document.querySelectorAll('.product__media-gallery-thumbails').forEach(function (list) {
      sync(list);
      new MutationObserver(function () {
        sync(list);
      }).observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Dopple finance message: the app reloads its iframe by setting src twice (about:blank, then its URL)
   once the page loads and again on every variant change. Each src change after the first adds an entry
   to the browser history, so Back only blanks the iframe instead of leaving the page. Load the iframe
   with location.replace instead, and only when its address actually changes. */
(function () {
  var frame = document.getElementById('dopplepay-cta-iframe');
  if (!frame) return;
  var native = Object.getOwnPropertyDescriptor(HTMLIFrameElement.prototype, 'src');
  var current = '';
  Object.defineProperty(frame, 'src', {
    configurable: true,
    get: function () {
      return current || native.get.call(this);
    },
    set: function (url) {
      url = String(url || '');
      if (!url || url === 'about:blank' || url === current) return;
      current = url;
      try {
        this.contentWindow.location.replace(url);
      } catch (error) {
        native.set.call(this, url);
      }
    },
  });
})();
